<template>
  <h3>
    <strong v-text="titleText" />
  </h3>
</template>
<script>

export default {
  name: 'MembershipTitle',
  props: {
    membershipTitle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    titleText() {
      return this.membershipTitle.union
        ? `${this.membershipTitle.union.attributes.name} ${this.membershipTitle.attributes.label}`
        : this.membershipTitle.attributes.label
    },
  },
}
</script>
